module.exports = __webpack_public_path__ + "img/google.27d206b3.svg";